import React, { useState } from "react";
import MyMap from "../../Maps/MyMap";
import MapIcon from "../../../assets/icons/mapping.svg2";
import { AbsoluteLoadingIndicator } from "../FullScreenLoadingIndicator";
import HelpButton from "../../HelpContent/HelpButton";
import WeatherAlerts from "../../Maps/WeatherAlerts";
import WeatherForecasts from "../../Maps/WeatherForecasts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

export default function MapWeatherForecastWidget() {
  const [loading, setLoading] = useState(false);
  const [weatherForecastDates, setWeatherForecastDates] = useState([]);

  const filters = {
    isForecast: false,
    start: "",
    radius: 30,
    steps: 8,
    date: weatherForecastDates.length > 0 ? weatherForecastDates[0] : "",
    mapZoomLevel: 7,
  };

  return (
    <div className="h-100 p-3 rounded-3">
      <AbsoluteLoadingIndicator loading={loading} />

      <div className="card-body d-flex flex-column justify-content-between h-100">
        <div className="text-white ">
          <MapIcon width={20} className="white opacity-50" />{" "}
          <Link
            className="btn p-0 text-white"
            to="/assets/maps"
            state={{
              mapFilters: { weatherForecastFilters: { isForecast: true } },
            }}
          >
            <span className="small fw-bold m-0 mx-2">WEATHER FORECAST MAP</span>
          </Link>
          <HelpButton
            helpKey="widget-weather-forecast-map"
            iconClassName="white"
          />{" "}
          <FontAwesomeIcon
            icon={faGripVertical}
            className="ms-4 opacity-50 widget-header"
          />
        </div>
        <hr className="text-white my-2" />

        <MyMap
          mapTypeControl={false}
          weatherForecastDates={weatherForecastDates}
        >
          <WeatherForecasts
            filters={filters}
            setLoading={setLoading}
            setWeatherForecastDates={setWeatherForecastDates}
          />
        </MyMap>
      </div>
    </div>
  );
}
